export const actionsPrefix = 'BRAND_START_ORDER_MODAL'

export const CHANGE_RETAILER_SEARCH_TEXT = `${actionsPrefix}/CHANGE_RETAILER_SEARCH_TEXT`
export const SET_RETAILER_ID = `${actionsPrefix}/SET_RETAILER_ID`
export const CHANGE_COLLECTION_SEARCH_TEXT = `${actionsPrefix}/CHANGE_COLLECTION_SEARCH_TEXT`
export const SET_ORPHAN_RETAILER = `${actionsPrefix}/SET_ORPHAN_RETAILER`
